import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { useAtomValue } from "jotai";

import { useToast } from "@whoosh/design-system/src/components/overlay/Toast/useToast";

import { useMutationWithError } from "../../../../../utils/hooks/useMutationWithError";
import { UpdateEmailOrPhoneProfileCompleteActionAtom } from "../atoms/stores";
import { useVerifyAndAssignPhoneCodeProfileMutation } from "./__generated__/useVerifyAndAssignPhoneCodeProfileMutation.graphql";

export const useVerifyAndAssignPhoneCodeProfile = () => {
  const [verifyAndAssignPhoneCodeProfile, isVerifyingAndAssigning] =
    useMutationWithError<useVerifyAndAssignPhoneCodeProfileMutation>(
      useVerifyAndAssignPhoneCodeProfileMutationString
    );

  const { showToast } = useToast();
  const completeAction = useAtomValue(
    UpdateEmailOrPhoneProfileCompleteActionAtom
  );

  const handlePhoneCodeVerification = ({
    phoneNumber,
    code,
    onError,
  }: {
    phoneNumber: string;
    code: string;
    onError: () => void;
  }) => {
    verifyAndAssignPhoneCodeProfile({
      variables: { input: { phoneNumber, code } },
      onCompleted: (res) => {
        showToast({
          description: t`Your phone number has been updated.`,
          semanticStyle: "success",
          toastId: "phone-number-updated",
        });
        completeAction?.();
      },
      onCompletedErrorCustom(errors) {
        onError();
        return errors;
      },
    });
  };

  return [handlePhoneCodeVerification, isVerifyingAndAssigning] as const;
};

export const useVerifyAndAssignPhoneCodeProfileMutationString = graphql`
  mutation useVerifyAndAssignPhoneCodeProfileMutation(
    $input: VerifyAndAssignPhoneInput!
  ) {
    responsePayload: verifyAndAssignPhone(input: $input) {
      success
      user {
        id
        email
        ... on MemberUser {
          id
          firstName
          lastName
          email
          phoneNumber {
            nationalNumber
          }
        }
      }
      errors {
        field
        code
        message
      }
    }
  }
`;
